var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"literature-box"},[_c('div',[_c('div',{staticClass:"literature-title",attrs:{"align":"center"}},[_vm._v("资料下载")]),_vm._v(" "),_vm._l((_vm.typeList),function(item){return _c('div',{staticClass:"literature-list-item",on:{"click":function($event){return _vm.goNext(item.id)}}},[_vm._v(_vm._s(item.type))])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c9c0d65","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiteratureAside.vue
// module id = null
// module chunks = 